import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import CameraAccessDenied from '../../../components/camera-access-denied';
import CameraAccessRequest from '../../../components/camera-access-request';
import CameraError from '../../../components/camera-error';
import Consent from '../../../id-doc/pages/consent';
import { useSelfieMachine } from '../../context/selfie-context';
import Capture from '../capture';
import Init from '../init';
import Processing from '../processing';
import Retry from '../retry';
type RouterProps = {
  onDone: () => void;
};
const Router = t0 => {
  const $ = _c(31);
  const {
    onDone
  } = t0;
  const [state, dispatch] = useSelfieMachine();
  const isDone = state.value === "complete" || state.value === "failure";
  let t1;
  let t2;
  if ($[0] !== isDone || $[1] !== onDone) {
    t1 = () => {
      if (isDone) {
        onDone();
      }
    };
    t2 = [isDone, onDone];
    $[0] = isDone;
    $[1] = onDone;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  if (state.value === "init") {
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Init />;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  if (state.value === "consent") {
    let t3;
    let t4;
    if ($[5] !== dispatch) {
      t3 = () => dispatch({
        type: "consentReceived"
      });
      t4 = () => dispatch({
        type: "navigatedToPrev"
      });
      $[5] = dispatch;
      $[6] = t3;
      $[7] = t4;
    } else {
      t3 = $[6];
      t4 = $[7];
    }
    let t5;
    if ($[8] !== state.context.authToken || $[9] !== state.context.device || $[10] !== state.context.onboardingConfig.logoUrl || $[11] !== state.context.onboardingConfig.orgName || $[12] !== state.context.onboardingConfig.privacyPolicyUrl || $[13] !== t3 || $[14] !== t4) {
      t5 = <Consent variant="selfie" authToken={state.context.authToken} device={state.context.device} onConsentSubmit={t3} onNavigatedToPrev={t4} tenantLogoUrl={state.context.onboardingConfig.logoUrl} tenantName={state.context.onboardingConfig.orgName} tenantPrivacyPolicyUrl={state.context.onboardingConfig.privacyPolicyUrl} />;
      $[8] = state.context.authToken;
      $[9] = state.context.device;
      $[10] = state.context.onboardingConfig.logoUrl;
      $[11] = state.context.onboardingConfig.orgName;
      $[12] = state.context.onboardingConfig.privacyPolicyUrl;
      $[13] = t3;
      $[14] = t4;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    return t5;
  }
  if (state.value === "requestCameraAccess") {
    let t3;
    if ($[16] !== dispatch) {
      t3 = <CameraAccessRequest variant="selfie" onClose={() => dispatch({
        type: "navigatedToPrev"
      })} onCameraAccessDenied={() => dispatch({
        type: "cameraAccessDenied",
        payload: {
          status: "denied"
        }
      })} onCameraError={cause => dispatch({
        type: "cameraErrored",
        payload: {
          cause
        }
      })} onSuccess={() => dispatch({
        type: "cameraAccessGranted",
        payload: {
          status: "granted"
        }
      })} />;
      $[16] = dispatch;
      $[17] = t3;
    } else {
      t3 = $[17];
    }
    return t3;
  }
  if (state.value === "cameraAccessDenied") {
    let t3;
    if ($[18] !== dispatch) {
      t3 = () => dispatch({
        type: "navigatedToPrev"
      });
      $[18] = dispatch;
      $[19] = t3;
    } else {
      t3 = $[19];
    }
    let t4;
    if ($[20] !== state.context.device || $[21] !== t3) {
      t4 = <CameraAccessDenied device={state.context.device} onClose={t3} />;
      $[20] = state.context.device;
      $[21] = t3;
      $[22] = t4;
    } else {
      t4 = $[22];
    }
    return t4;
  }
  if (state.value === "cameraErrored") {
    let t3;
    if ($[23] !== dispatch) {
      t3 = () => dispatch({
        type: "navigatedToPrev"
      });
      $[23] = dispatch;
      $[24] = t3;
    } else {
      t3 = $[24];
    }
    const t4 = state.context.cameraErrorCause ?? "other-error";
    let t5;
    if ($[25] !== t3 || $[26] !== t4) {
      t5 = <CameraError onBack={t3} cause={t4} />;
      $[25] = t3;
      $[26] = t4;
      $[27] = t5;
    } else {
      t5 = $[27];
    }
    return t5;
  }
  if (state.value === "capture") {
    let t3;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Capture />;
      $[28] = t3;
    } else {
      t3 = $[28];
    }
    return t3;
  }
  if (state.value === "processing") {
    let t3;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Processing />;
      $[29] = t3;
    } else {
      t3 = $[29];
    }
    return t3;
  }
  if (state.value === "retry") {
    let t3;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Retry />;
      $[30] = t3;
    } else {
      t3 = $[30];
    }
    return t3;
  }
  return null;
};
export default Router;